import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StatisticalForecastingDeepDiveComponent } from './statistical-forecasting-deep-dive.component';

const routes: Routes = [
    {
        path: '',
        component: StatisticalForecastingDeepDiveComponent
    }, 
    {
      path: ':id',
      component: StatisticalForecastingDeepDiveComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class StatisticalForecastingDeepDiveRoutingModule { }
